import { rest } from "msw";
import { FormCategoryAdapter } from "../adapters/FormCategory.ts";
import type { DomainConfig } from "../config.ts";
import {
  FormCategorySchema,
  type FormCategoryType,
} from "../schemas/FormCategoriesSchemas.ts";
import {
  getApiUrlWithEndpoint,
  type BuildMockHandlersType,
} from "./handlers.ts";
import { DomainFaker, DomainMock } from "./utils.ts";

export const FormCategoryMock = new DomainMock<
  FormCategoryType,
  typeof FormCategorySchema
>(
  FormCategorySchema,
  () => {
    const createdAt = DomainFaker.en.date.past();

    return {
      id: DomainFaker.en.string.uuid(),
      company_id: DomainFaker.en.string.uuid(),
      name: DomainFaker.en.lorem.words({ min: 2, max: 4 }),
      archived: DomainFaker.en.helpers.arrayElement([true, false]),
      created_at: createdAt.toISOString(),
      updated_at: DomainFaker.en.date
        .between({ from: createdAt, to: new Date() })
        .toISOString(),
    };
  },
  true
).fix();

export const buildFormCategoryHandlers: BuildMockHandlersType<
  typeof FormCategoryAdapter
> = (configData: DomainConfig) => {
  const { nodeURL: url } = configData;

  return {
    getOne: rest.get(
      getApiUrlWithEndpoint({
        url,
        version: 1,
        endpoint: "/form_categories/:id",
      }),
      (req, res, ctx) => {
        const { id } = req.params;

        if (typeof id !== "string") {
          return res(ctx.status(400));
        }

        const mockData = {
          ...FormCategoryMock.mock,
          id,
        };

        return res(ctx.status(200), ctx.json(mockData));
      }
    ),
  };
};
